<template>
  <!--订单弹窗-->
  <div id="upOrder">
    <van-dialog v-model="showType" :showConfirmButton="false">
      <div class="upOrder_con">
        <div class="upOrder_con_top" style="padding: 0 .3rem;">
          <p class="title">
            {{ $t('cont.t16') }}
          </p>
          <span class="close" @click="errView">
            ×
          </span>
        </div>
        <div v-for="(item, index) in orderInfo" :key="index" style="padding: 0 .3rem;">
          <!-- <div class="textInfo">{{ $t('cont.t17') }}： <span>{{ item.addtime }}</span></div> -->
          <div class="textInfo">{{ $t('cont.t18') }}： <span>{{ item.oid }}</span></div>
          <div class="upOrder_con_info">
            <div class="l">
              <img :src="item.goods_pic" alt="">
            </div>
            <div class="r">
              <p>{{ item.goods_name }}1</p>
              <p>{{ item.shop_name }}</p>
              <p style="font-size: .26rem;line-height: .27rem;">{{ item.synopsis }}</p>
            </div>
          </div>
          <div class="upOrder_con_price">
            <div>
              <p>{{ $t('cont.t19') }}:</p>
              <span>{{ item.num }}</span>
            </div>
            <div>
              <!-- <span>{{ Math.max(Number(item.num ?? 0) - Number(item.balance ?? 0), 0).toFixed(2) }}</span> -->
              <p>{{ $t('movie.t03') }}:</p>
              <span :style="{
                color: Math.max(Number(item.num ?? 0) - Number(item.balance ?? 0), 0) > 0 ? '#f56c6c' : '#67c23a'
              }">
                {{ Math.max(Number(item.num ?? 0) - Number(item.balance ?? 0), 0).toFixed(2) }}
              </span>
            </div>
            <div>
              <p>{{ $t('cont.t09') }}:</p>
              <span>{{ item.commission }}</span>
            </div>
          </div>
          <div class="upOrder_con_row" style="border-bottom: .02rem solid #000;">
            <p class="title">{{ $t('cont.t21') }}</p>
            <van-rate v-model="rate1" :size="25" color="#ffca3e" void-icon="star" void-color="#CECECE" />
          </div>
          <div class="upOrder_con_row" style="border-bottom: .02rem solid #000;">
            <p class="title">{{ $t('cont.t22') }}</p>
            <van-rate v-model="rate2" :size="25" color="#ffca3e" void-icon="star" void-color="#CECECE" />
          </div>
          <div class="upOrder_con_row">
            <p class="title">{{ $t('cont.t23') }}</p>
            <input type="text" v-model="iptValue" :placeholder="$t('cont.t23')">
          </div>
          <div class="upOrder_con_bottom">
            <div class="btn error" @click="dialogErr()">{{ $t('cont.t24') }}</div>
            <div class="btn" @click="dialogSce(item.num)">{{ $t('cont.t15') }}</div>
          </div>
        </div>
      </div>

    </van-dialog>
  </div>
</template>
<script>
import { SERVERTAPI } from "@/config";
import { SET_LOADING } from "@/store/mutations";
import { Dialog } from "vant";

export default {
  props: {
    oid: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderInfo: [], // 订单详情
      showType: false, // 订单弹窗
      apiSrc: SERVERTAPI,
      rate1: 0,
      rate2: 0,
      iptValue: ''
    }
  },
  created() {
    console.log(this.oid);
    // this.$http.getGoodsInfo({id:'UB2605091542432358'})
    // this.$http.getGoodsInfo({oid:'UB2605091542432358'})
    let params = new URLSearchParams();
    params.append('id', this.oid);
    this.$http.getOrderInfo(params).then(res => {
      if (res.code === 0) {
        this.orderInfo = res.data;
        this.showType = true;
      } else {
        this.$toast(res.info);
      }
    })
  },
  methods: {
    errView() {
      this.$emit('data-sent', this.show);
    },
    //订单弹窗
    // 提交订单按钮
    dialogSce(num) {
      if (!this.rate1 || !this.rate2) {
        this.$toast(this.$t('cont.t25'));
        return false;
      }
      this.userinfo = JSON.parse(localStorage.getItem('userInfo'));
      // 判断余额
      this.$store.commit('SET_LOADING', true); // 打开loadingType
      let params = new URLSearchParams();
      params.append('oid', this.oid);
      this.$http.getDoOrder(params).then(res => {
        setTimeout(() => {
        }, 100000000)
        if (res.code === 0) {
          this.$store.commit('SET_LOADING', false);
          this.$toast(this.$t('cont.t26'));
          setTimeout(() => {
            this.$emit('load');
            this.dialogErr();
            // location.reload();
          }, 1000)
        } else {
          this.$store.commit('SET_LOADING', false);
          if (parseFloat(this.userinfo.balance) < parseFloat(num)) {
            Dialog.alert({
              message: res.info,
              confirmButtonText: this.$t('user.t42')
            }).then(() => {
              this.$router.push('/recharge');
            });
          } else {
            this.$toast(res.info);
          }


        }
      })
    },
    // 取消按钮
    dialogErr() {
      this.errView();
    },
  }
}
</script>
<style lang="less" scoped>
#upOrder {
  .upOrder_con {
    padding: .3rem 0;

    .upOrder_con_top {
      display: flex;
      margin-bottom: .24rem;
      justify-content: space-between;

      p.title {
        font-size: .45rem;
        color: #333;
      }

      span.close {
        font-size: .5rem;
        font-weight: 700;
        opacity: .5;
        text-shadow: 0 .02rem 0 #fff;
      }
    }

    .textInfo {
      font-size: .35rem;
      color: #9e9e9e;
    }

    .upOrder_con_info {

      margin: .1rem 0;
      display: flex;
      overflow: hidden;
      border-radius: .05rem;
      background-color: #f2f2f2;
      gap: .2rem;

      .l {
        width: 2.7rem;
        padding-left: .1rem;


        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .r {
        flex: 1;
        padding: .14rem .1rem;


        p {
          margin-bottom: .4rem;
          color: #424242;
          font-size: .3rem;
        }
      }
    }

    .upOrder_con_price {
      padding: .2rem;
      border-bottom: .02rem solid #000;
      display: flex;
      flex-direction: column;

      &>div {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .03rem 0;

        span {
          font-size: .3rem;
          font-weight: 700;
        }

        p {
          font-size: .36rem;
          font-weight: 700;

        }
      }
    }

    .upOrder_con_row {
      display: flex;
      padding: .2rem .3rem;
      justify-content: space-between;

      p.title {
        font-size: .4rem;
        color: #333;
      }

      input {
        width: 50%;
        font-size: .4rem;

        &::placeholder {
          color: #CDCDCD;
        }
      }
    }

    .upOrder_con_bottom {
      margin-top: .6rem;
      display: flex;
      justify-content: center;
      gap: .4rem;

      .btn {
        background-color: #121212;
        color: #fff;
        padding: .1rem .2rem;
        border-radius: .1rem;
        font-size: .3rem;
      }

      .btn.error {
        color: #000;
        background-color: #fff;
        box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
        -webkit-box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
      }
    }
  }

  ::v-deep {
    .van-overlay {
      background-color: rgba(0, 0, 0, .5);
    }

    .van-dialog {
      border-radius: .12rem;

      .van-dialog__content {
        border: none;
        text-align: left;
      }
    }
  }
}
</style>
